import React, { useCallback, useEffect, useState, useRef, lazy } from 'react';
const SLIDES = [{
  src: 'https://res.cloudinary.com/dqvi0nktw/image/upload/f_auto,q_auto/carrusel1_fiauug',
  alt: 'Bikini crochet - Imagen 1'
}, {
  src: 'https://res.cloudinary.com/dqvi0nktw/image/upload/f_auto,q_auto/carrusel2_a9yjwp',
  alt: 'Bikini crochet - Imagen 2'
}, {
  src: 'https://res.cloudinary.com/dqvi0nktw/image/upload/f_auto,q_auto/carrusel3_1_zcquim',
  alt: 'Bikini crochet - Imagen 3'
}, {
  src: 'https://res.cloudinary.com/dqvi0nktw/image/upload/f_auto,q_auto/carrusel4_d5vuj6',
  alt: 'Bikini crochet - Imagen 4'
}, {
  src: 'https://res.cloudinary.com/dqvi0nktw/image/upload/v1774995942/carrusel6_ahz57m.jpg',
  alt: 'Bikini crochet - Imagen 5'
}];
const AUTOPLAY_INTERVAL = 3500;
interface HeroCarouselProps {
  className?: string;
}
export function HeroCarousel({
  className = ''
}: HeroCarouselProps) {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const autoplayRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const totalSlides = SLIDES.length;
  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 400);
  }, [isTransitioning]);
  const next = useCallback(() => {
    goTo((current + 1) % totalSlides);
  }, [current, totalSlides, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + totalSlides) % totalSlides);
  }, [current, totalSlides, goTo]);
  // Autoplay
  useEffect(() => {
    autoplayRef.current = setInterval(next, AUTOPLAY_INTERVAL);
    return () => {
      if (autoplayRef.current) clearInterval(autoplayRef.current);
    };
  }, [next]);
  const resetAutoplay = useCallback(() => {
    if (autoplayRef.current) clearInterval(autoplayRef.current);
    autoplayRef.current = setInterval(next, AUTOPLAY_INTERVAL);
  }, [next]);
  // Touch handlers
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    if (autoplayRef.current) clearInterval(autoplayRef.current);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    const threshold = 50;
    if (diff > threshold) {
      next();
    } else if (diff < -threshold) {
      prev();
    }
    resetAutoplay();
  };
  // Mouse drag handlers for desktop
  const mouseStartX = useRef(0);
  const isDragging = useRef(false);
  const handleMouseDown = (e: React.MouseEvent) => {
    mouseStartX.current = e.clientX;
    isDragging.current = true;
    if (autoplayRef.current) clearInterval(autoplayRef.current);
  };
  const handleMouseUp = (e: React.MouseEvent) => {
    if (!isDragging.current) return;
    isDragging.current = false;
    const diff = mouseStartX.current - e.clientX;
    const threshold = 50;
    if (diff > threshold) {
      next();
    } else if (diff < -threshold) {
      prev();
    }
    resetAutoplay();
  };
  const handleMouseLeave = () => {
    if (isDragging.current) {
      isDragging.current = false;
      resetAutoplay();
    }
  };
  return <div className={`relative select-none ${className}`} data-id="element-317">
      {/* Slides container */}
      <div ref={containerRef} className="overflow-hidden rounded-2xl aspect-square" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} onMouseLeave={handleMouseLeave} data-id="element-318">
        <div className="flex h-full transition-transform duration-400 ease-in-out" style={{
        transform: `translateX(-${current * 100}%)`
      }} data-id="element-319">
          {SLIDES.map((slide, i) => <div key={i} className="w-full flex-shrink-0 h-full bg-pink-50" data-id="element-320">
              <img src={slide.src} alt={slide.alt} loading={i === 0 ? 'eager' : 'lazy'} decoding="async" className="w-full h-full object-cover" draggable={false} data-id="element-321" />
            </div>)}
        </div>
      </div>

      {/* Dot indicators */}
      <div className="flex justify-center gap-2 mt-3" data-id="element-322">
        {SLIDES.map((_, i) => <button key={i} onClick={() => {
        goTo(i);
        resetAutoplay();
      }} className={`rounded-full transition-all duration-300 ${i === current ? 'w-6 h-2 bg-pink-dark' : 'w-2 h-2 bg-pink-dark/30'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-323" />)}
      </div>
    </div>;
}